
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.484 9.14v.04c0 .53.055.88.164 1.047.11.166.36.296.75.39V11H4.164v-.383c.396-.094.646-.224.75-.39.11-.167.164-.516.164-1.047v-.032c-1.542-.041-2.706-.333-3.492-.875-.787-.546-1.18-1.39-1.18-2.53 0-2.298 1.558-3.516 4.672-3.657 0-.552-.068-.898-.203-1.04C4.74.902 4.503.793 4.165.72V.336h3.233v.383c-.338.078-.575.187-.71.328-.136.14-.204.482-.204 1.023h.008c1.386 0 2.508.271 3.367.813.865.536 1.297 1.375 1.297 2.515 0 1.178-.377 2.07-1.133 2.68-.755.61-1.934.964-3.539 1.063zm0-6.43v5.782c2.068-.068 3.102-1.036 3.102-2.906 0-1.906-1.034-2.865-3.102-2.875zM5.078 8.517V2.734c-2.068.089-3.101 1.052-3.101 2.891 0 .969.242 1.688.726 2.156.49.469 1.281.714 2.375.735z","fill":"currentColor"}})])
          )
        }
      }
    